import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useFormikForm } from '#/common/hooks';
import { ROUTES } from '#/routes';
import { apiEndpoints, usePostMutation } from '#/services';
import {
    ACCESS_TOKEN,
    ForgotValidationSchema,
    forgotInInitialValues,
    getLocalStorageItem,
    getSessionStorageItem,
} from '#/utils';

export function useForgetPassword() {
    const navigate = useNavigate();

    const [hasEmailSent, setHasEmailSent] = useState(false);
    const { mutate: forgotApiCall, isPending: forgotApiLoading } = usePostMutation({
        url: apiEndpoints.FORGOT_PASSWORD,
        onSuccess: forgotCallSuccess,
    });

    function forgotCallSuccess() {
        setHasEmailSent(true);
    }

    const handleForgot = async values => {
        forgotApiCall({
            payload: values,
        });
    };

    const navigateToLogin = () => {
        setHasEmailSent(false);
        navigate(ROUTES.LOGIN);
    };

    const {
        handleChange: handleChangeForgot,
        handleSubmit: handleSubmitForgot,
        errors: forgotErrors,
        touched: forgotTouched,
        values: forgotValues,
        setFieldValue: setForgotValues,
    } = useFormikForm(forgotInInitialValues, handleForgot, ForgotValidationSchema);

    useEffect(() => {
        if (getLocalStorageItem(ACCESS_TOKEN) || getSessionStorageItem(ACCESS_TOKEN)) navigate(ROUTES.HOME);
    }, []);
    return {
        navigateToLogin,
        handleChangeForgot,
        handleSubmitForgot,
        forgotErrors,
        forgotTouched,
        forgotValues,
        setForgotValues,
        forgotApiLoading,
        hasEmailSent,
    };
}
